import { RouterProvider } from 'react-router-dom';

import { useAuth, useRole } from '@/entities/user';

import { actorRouter } from './actor';
import { adminRouter } from './admin';
import { authRouter } from './auth';
import { directorRouter } from './director';

/**
 * Роутер приложения
 */
export const Router = () => {
  const { isLoggedIn } = useAuth();
  const role = useRole();

  if (window.location.pathname.startsWith('/admin-v2')) {
    return <RouterProvider router={adminRouter} />;
  }

  let router = authRouter;

  if (isLoggedIn) {
    router = role === 'actor' ? actorRouter : directorRouter;
  }

  return <RouterProvider router={router} />;
};
